import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import Icon from "../../sub/Icon";

class BarCodesExportModal extends React.Component {
  render() {
    return (
      <Modal show={true} onHide={() => this.props.close()} backdrop={"static"}>
        <Modal.Header closeButton>
          <Modal.Title>Exporter les codes-barres du parc</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Choisissez le format d'export :</p>
          <div className="d-flex justify-content-center" style={{ gap: "1rem" }}>
            <Button variant="primary" onClick={() => this.props.onExportPDF()}>
              <Icon icon="file-pdf" className="mr-2" />
              Format A4 (PDF)
            </Button>
            <Button variant="success" onClick={() => this.props.onExportCSV()}>
              <Icon icon="file-csv" className="mr-2" />
              Format CSV (DYMO)
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.props.close()}>
            <FormattedMessage id="Cancel" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default BarCodesExportModal;
